import { useSelector } from 'react-redux';
import ProviderCommonApi from '../../../API/provider/common-api';
import SamsonApi from '../../../API/provider/samson-api';
import { Column, Row } from '../../../components/Basic/Blocks';
import WhiteBlock from '../../../components/Basic/Blocks/WhiteBlock';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import ProviderProductsTable from '../../../components/Providers/Blocks/ProductsTable';
import ProviderDasboardContentWhiteBlock from '../../../components/Providers/Blocks/ProviderDasboardContent';
import ProviderUpdateStatusBlock from '../../../components/Providers/Blocks/ProviderUpdateStatus';
import { PROVIDERS, TYPE_BUTTONS } from '../../../constans';

const SamsonPage = ({ ...props }) => {
  const user = useSelector((store) => store.user);

  const providerId = PROVIDERS.SAMSON.id;

  const loadProducts = async () => {
    await SamsonApi.loadProducts({})
  };

  const access = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <Row style={{ alignItems: 'unset' }}>
          <WhiteBlock style={{ marginRight: '20px' }} title={'Самсон'}>
            <Column style={{ marginBottom: '15px' }}>
              <Row>
                <Button type={TYPE_BUTTONS.BLUE} onClick={loadProducts} style={{ marginRight: '15px' }}>
                  Обновить остатки
                </Button>
                {access && (
                  <Row style={{ alignItems: 'flex-start' }}>
                    <Button
                      type={TYPE_BUTTONS.RED}
                      onClick={() => ProviderCommonApi.nullStocks({ data: { providerId } })}
                      style={{ marginRight: '15px' }}
                    >
                      Обнулить остатки
                    </Button>
                  </Row>
                )}
              </Row>

              <ProviderUpdateStatusBlock providerId={providerId} />
            </Column>
          </WhiteBlock>
          <ProviderDasboardContentWhiteBlock providerId={providerId} />
        </Row>
        <ProviderProductsTable providerId={providerId} isMinPackage={true} />
      </Content>
    </>
  );
};

export default SamsonPage;
